export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10346.b64126fc.jpg";